import routesConfig from '../route';

const routes: any = [];

routesConfig.forEach(element => {
  routes.push(...element.routes)
});

export default routes;
